// eslint-disable-next-line
import React, { useEffect, useRef, useState } from "react";
/* Components */
import Button from "../button/button";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { fetchChatGPT } from "../../services/chat.service";
import useSnackbarStore from "../../store/snackbarStore";
import { useMixPanel } from "../../hooks/useMixPanel";
import { useTranslation } from "react-i18next";
import useChatGPTStore from "../../store/useChatGPT.store";
import useUsageStore from "../../store/useUsageStore";
import useSessionStore from "../../store/useSessionStore";
import useGlobalStore from "../../store/useGlobalStore";
import { storeUsage } from "../../services/useCaseUsage.service";
import { FormProvider, useForm } from "react-hook-form";
import TextInput2 from "../form-elements/TexInput2/TextInput2";
import TextArea2 from "../form-elements/TextArea2/textArea2";
import useUserStore from "../../store/useUser.store";
import { v4 as uuidv4 } from "uuid";
import { MIX_PANEL_EVENTS } from "../../utils/constans";
import useCaseStore from "../../store/useCaseStore";
import SwitchToggle from "../form-elements/ToggleSwitchInput/toggleSwitchInput";

const FormRubric = () => {
  const navigate = useNavigate();
  const { show } = useSnackbarStore();
  const { sendEvent } = useMixPanel();
  const { t } = useTranslation();
  const { formObject } = useChatGPTStore();
  // eslint-disable-next-line
  const { gptSuccess, setGPTSuccess, gptLoading, setGPTLoading } =
    useGlobalStore();
  const { setUsage } = useUsageStore();
  const { user } = useSessionStore();
  const methods = useForm();
  const { handleSubmit, setValue } = methods;
  const sessionIdRef = useRef(null);
  const { lang } = useUserStore();
  const { useCaseList, setAssesMessages, setAssesUserContext } = useCaseStore();

  const currentUseCase = useCaseList?.find(
    (e) => e.description === "rubrica_1",
  );
  const useCaseId = currentUseCase ? currentUseCase.id : null;

  const questions = [
    {
      field: "clase",
      question: t("formulario_rubrica_contexto_clase"),
      default: null,
    },
    {
      field: "grado",
      question: t("formulario_rubrica_contexto_grado"),
      default: null,
    },
    {
      field: "edad",
      question: t("formulario_rubrica_contexto_edad"),
      default: "Inferir según el grado",
    },
    {
      field: "estandar",
      question: t("formulario_rubrica_contexto_estandar"),
      default: null,
    },
    {
      field: "criterios_evaluacion",
      question: t("formulario_rubrica_contexto_criterios"),
      default: null,
    },
    {
      field: "niveles_desempeno",
      question: t("formulario_rubrica_contexto_niveles"),
      default: null,
    },
    {
      field: "comentarios",
      question: t("formulario_rubrica_contexto_comentarios"),
      default: "No",
    },
    {
      field: "consideraciones",
      question: t("formulario_rubrica_contexto_consideraciones"),
      default: "no aplican",
    },
  ];

  const storeUsagemutation = useMutation(storeUsage, {
    onSuccess: (data) => {
      setUsage({
        total: data?.total,
        limit: data?.limit,
        percentage: data?.usagePercentage,
      });
    },
    onError: () => {},
  });

  const mutation = useMutation(fetchChatGPT, {
    onSuccess: (res) => {
      storeUsagemutation.mutate({
        email: user?.email,
        use_case_id: useCaseId,
        session_id: sessionIdRef.current,
      });
      sendEvent(MIX_PANEL_EVENTS.rubricUseCaseResponse);
      setAssesMessages(res?.messages);
      setGPTLoading(false);
      setGPTSuccess(true);
      navigate(`/design-rubric?sessionId=${sessionIdRef.current}`);
    },
    onError: (err) => {
      if (err.response.status === 403) {
        navigate("/");
      } else {
        show("Ocurrio un error, vuelve a intentar", "error");
      }
      setGPTLoading(false);
      setGPTSuccess(false);
    },
  });

  const onSubmit = (formData) => {
    const prepareQuestions = questions.map((e) => ({
      ...e,
      value: formData[e.field],
    }));

    const parsedQuestions = prepareQuestions.map(
      (e) => `${e.question}: ${!e.value && e.default ? e.default : e.value}`,
    );

    const content = `Context: \`\`\`${parsedQuestions.join("  ")}\`\`\` `;
    console.log("content ", content);
    sessionIdRef.current = uuidv4();
    const payload = {
      messages: [{ role: "user", content }],
      type: "rubrica_1",
      lang,
      session_id: sessionIdRef.current,
      use_case_id: useCaseId,
    };
    setAssesUserContext(content);
    setGPTLoading(true);
    sendEvent(MIX_PANEL_EVENTS.rubricUseCaseSend);
    mutation.mutate(payload);
  };

  useEffect(() => {
    sendEvent(MIX_PANEL_EVENTS.rubricUseCaseView);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (formObject.length) {
      formObject.forEach((element) => {
        setValue(element.field, element.value);
      });
    }
  }, [formObject, setValue]);

  useEffect(() => {
    return () => {
      setAssesUserContext("");
      setGPTSuccess(false);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="input-row">
            <TextInput2
              label={t("formulario_rubrica_campo_clase_materia_label")}
              labelInstruction={t(
                "formulario_rubrica_campo_clase_materia_instruction",
              )}
              name="clase"
              placeHolder={t(
                "formulario_rubrica_campo_placeholder_clase_materia",
              )}
              maxLength={"60"}
              required
            />
            <TextInput2
              label={t("formulario_rubrica_campo_grado_nivel_label")}
              labelInstruction={t(
                "formulario_rubrica_campo_grado_nivel_instruction",
              )}
              name="grado"
              placeHolder={t(
                "formulario_rubrica_campo_placeholder_grado_nivel",
              )}
              maxLength={"20"}
              required
            />
            <TextInput2
              label={t("formulario_rubrica_campo_edad_label")}
              labelInstruction={t("formulario_rubrica_campo_edad_instruction")}
              name="edad"
              placeHolder={t("formulario_rubrica_campo_placeholder_edad")}
              maxLength={"20"}
              required
            />
          </div>
          <TextArea2
            label={t("formulario_rubrica_campo_estandar_label")}
            labelInstruction={t(
              "formulario_rubrica_campo_estandar_instruction",
            )}
            name="estandar"
            placeholder={t("formulario_rubrica_campo_placeholder_estandar")}
            maxLength={"2000"}
            required
          />
          <div className="input-row">
            <TextInput2
              label={t("formulario_rubrica_campo_criterios_label")}
              labelInstruction={t(
                "formulario_rubrica_campo_criterios_instruction",
              )}
              name="criterios_evaluacion"
              placeHolder={t("formulario_rubrica_campo_placeholder_criterios")}
              maxLength={10}
              minLength={2}
              type='number'
              required
            />
            <TextInput2
              label={t("formulario_rubrica_campo_niveles_label")}
              labelInstruction={t(
                "formulario_rubrica_campo_niveles_instruction",
              )}
              name="niveles_desempeno"
              placeHolder={t("formulario_rubrica_campo_placeholder_niveles")}
              maxLength={10}
              minLength={1}
              type='number'
              required
            />
            <SwitchToggle
              label={t("formulario_rubrica_campo_comentarios_label")}
              labelInstruction={t(
                "formulario_rubrica_campo_comentarios_instruction",
              )}
              value1={t("formulario_rubrica_campo_placeholder_comentario_no")}
              value2={t("formulario_rubrica_campo_placeholder_comentario_si")}
              name="comentarios"
            />
          </div>
          <TextArea2
            label={t("formulario_rubrica_campo_consideraciones_label")}
            labelInstruction={t(
              "formulario_rubrica_campo_consideraciones_instruction",
            )}
            name="consideraciones"
            placeholder={t(
              "formulario_rubrica_campo_placeholder_consideraciones",
            )}
            maxLength={"2000"}
          />
          <div className="form-CTA">
            <Button
              label={
                gptLoading ? `${t("creating")} ...` : t("createRubricaButton")
              }
              variant="primary"
              typeB="submit"
              disabled={gptLoading}
            />
          </div>
        </form>
      </FormProvider>
    </>
  );
};

export default FormRubric;
